import type { OrganizationInvitationResponse } from "@kontextwerk/control-web-client"
import type { MembershipInvitationsApi } from "../../../../../../../../../../../api/kehrblatt/membership-invitations"
import {
  runConfirmedChange,
  type ConfirmedChangeOutcome,
} from "../../../../../_shared/_logic/confirmed-change"
import { invitationExpiresAt } from "../_shared/_logic/invitation-lifetime"
import type { InvitationRow } from "../_shared/_logic/table"

export type InvitationCommand = Readonly<{
  api: MembershipInvitationsApi
  invitation: InvitationRow
}>

export type InvitationCommandResult = ConfirmedChangeOutcome<OrganizationInvitationResponse>

/** Replaces the pending invitation by a new one for the same recipient and role. */
export const resendInvitation = ({
  api,
  invitation,
  now = Date.now(),
}: InvitationCommand & { now?: number }): Promise<InvitationCommandResult> =>
  runConfirmedChange(
    {
      title: "Einladung erneut senden",
      description: `${invitation.email} erhält eine neue Einladung; die bisherige wird ungültig. Bitte bestätigen Sie die Aktion mit Ihrem aktuellen Passwort.`,
      actionLabel: "Erneut senden",
    },
    () => api.resend(invitation.invitationId, invitationExpiresAt(now)),
  )

/** Revokes the pending invitation; its link can no longer be accepted. */
export const revokeInvitation = ({
  api,
  invitation,
}: InvitationCommand): Promise<InvitationCommandResult> =>
  runConfirmedChange(
    {
      title: "Einladung zurückziehen",
      description: `Die Einladung an ${invitation.email} kann danach nicht mehr angenommen werden. Bitte bestätigen Sie die Aktion mit Ihrem aktuellen Passwort.`,
      actionLabel: "Zurückziehen",
    },
    () => api.revoke(invitation.invitationId),
  )
